import { render, staticRenderFns } from "./lbjMembershipCard.vue?vue&type=template&id=108facc2&scoped=true&"
import script from "./lbjMembershipCard.vue?vue&type=script&lang=js&"
export * from "./lbjMembershipCard.vue?vue&type=script&lang=js&"
import style0 from "./lbjMembershipCard.vue?vue&type=style&index=0&id=108facc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108facc2",
  null
  
)

export default component.exports